import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { DateTime } from "luxon";

import Image from "../../components/image";
import { getUrl } from "../../utils/helper";

class Item extends Component {
    render() {
        const { item, target, showTopCategory, related } = this.props;

        return (
            <Link
                className={`flex flex-col ${related ? "text-white" : ""}`}
                target={target}
                to={getUrl("bookmarks/" + item.tag.slug + "/" + item.slug)}
                title={item.title}
            >
                {item.cover && (
                    <Image
                        alt={item.cover.alt || item.title}
                        url={item.cover.url}
                        aspectRatio="aspect-ratio-4/3"
                        styleExtra="mb-20"
                    />
                )}
                <h1 className={"font-judge font-bold text-30 mb-12"}>
                    {item.title.toUpperCase()}
                </h1>
                <div
                    className={`border-b ${
                        related ? "border-white" : "border-blue"
                    } pb-24 flex-1`}
                >
                    <p
                        className={
                            "font-bold text-17 xl:text-23 leading-tight line-clamp-5"
                        }
                    >
                        {item.summary}
                    </p>
                </div>
                <div className="flex justify-between pt-10">
                    <p
                        style={
                            showTopCategory
                                ? { color: related ? "white" : item.tag.color }
                                : {}
                        }
                        className="font-bold text-17"
                    >
                        {item.tag.name}
                    </p>
                    <p className="font-bold text-17">
                        {DateTime.fromISO(item.publish_date).toLocaleString(
                            DateTime.DATE_MED
                        )}
                    </p>
                </div>
            </Link>
        );
    }
}

Item.defaultProps = {
    showTopCategory: false,
    related: false,
};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Item);
